import { AuthorizationsDocumentsTextRequestInterface } from '../../../interfaces/request/authorizations-documents-text/authorizations-documents-text-request-interface';

export class CpAuthorizationsDocumentsTextRequestModel implements AuthorizationsDocumentsTextRequestInterface {
  subServiceId: number = -1;
  specialtyId: number = -1;

  constructor(init?: Partial<CpAuthorizationsDocumentsTextRequestModel>) {
    Object.assign(this, init);
  }
}
